import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { EventType } from '@/services/Calendar/Events/Interfaces';

export class CreateEventForm {
  public type: number = 0;
  public name: string = '';
  public description: string = '';
  public location: string = '';
  public author: string = '';
  public date: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    type: [
      (v: number) => {
        // @ts-ignore
        if (Object.keys(EventType)[v] != v) {
          return 'The field value is not valid.';
        }

        return true;
      },
    ],
    name: [
      (v: string) => !!v || 'Name field is required.',
    ],
    description: [
      (v: string) => !!v || 'Date field is required.',
    ],
    author: [
      (v: string) => !!v || 'This field is required.',
    ],
    date: [
      (v: string) => !!v || 'This field is required.',
    ],
  };
}
